import { Chip, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { Repeat } from "lib/@components/repeat"

export function MacroLinkedView({ linked = [], macros = [] }) {
    const options = resolveLinkedMacros(linked, macros)

    return (
        <If truthy={options.length > 0}>
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                <Repeat list={options} pass="macro" keyFn="id" item={<LinkedChip />} />
            </Stack>
            <Else>
                <Typography>No linked macros.</Typography>
            </Else>
        </If>
    )
}

function LinkedChip({ macro }) {
    return <Chip label={macro?.name || macro?.id} size="small" variant="outlined" />
}

function resolveLinkedMacros(linked, macros) {
    const byId = {}
    for (const macro of macros ?? []) {
        if (!macro?.id) continue
        byId[macro.id] = macro
    }
    const resolved = []
    for (const id of linked ?? []) {
        const macro = byId[id]
        if (!macro) continue
        resolved.push(macro)
    }
    return resolved
}
